import React from "react";
import i18n from "i18next";
import "./AnimationOptions.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MarkEditor from "../../_editor/components/rich_plugins/mark_editor/MarkEditor";
import Mark from "../../common/components/mark/Mark";
import img_broken from "./../../dist/images/broken_link.png";
import img_placeholder from "./../../dist/images/placeholder.svg";
import Image from "./Image";

export function AnimationOptions(base) {
  return {
    getConfig: function () {
      return {
        name: "AnimationOptions",
        displayName: i18n.t("AnimationOptions.PluginName"),
        category: "image",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        initialWidth: "auto",
        initialHeight: "auto",
        // initialWidthSlide: '30%',
        // initialHeightSlide: '30%',
        icon: "directions_run",

        aspectRatioButtonConfig: {
          location: ["main", "structure"],
          defaultValue: true,
        },
        isRich: true,
        marksType: {
          name: i18n.t("AnimationOptions.pos"),
          key: "value",
          format: "[x,y]",
          default: "50,50",
          defaultColor: "#000001",
        },
        createFromLibrary: ["image/*", "url"],
        searchIcon: true,
        needsPointerEventsAllowed: true,
        // searchIcon: ['image/*', 'url'],
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            basic: {
              __name: IdealStudio.i18n.t("AnimationOptions.source"),
              icon: "link",
              buttons: {
                url: {
                  __name: "URL",
                  type: "external_provider",
                  value: state.url,
                  accept: "image/*",
                },
                allowDeformed: {
                  __name: IdealStudio.i18n.t("AnimationOptions.allowDeformed"),
                  type: "checkbox",
                  checked: state.allowDeformed,
                },
                scale: {
                  __name: IdealStudio.i18n.t("AnimationOptions.scale"),
                  type: "range",
                  min: 0,
                  max: 20,
                  step: 0.2,
                  value: state.scale || 1,
                },
                hyperlink: {
                  __name: IdealStudio.i18n.t("AnimationOptions.hyperlink"),
                  type: "text",
                  value: state.hyperlink,
                  placeholder: IdealStudio.i18n.t("AnimationOptions.link_placeholder"),
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("AnimationOptions.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("AnimationOptions.padding"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("AnimationOptions.background_color"),
                  type: "color",
                  value: "rgba(255,255,255,0)",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("AnimationOptions.border_size"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("AnimationOptions.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("AnimationOptions.border_color"),
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("AnimationOptions.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("AnimationOptions.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getRichMarkInput: function (state, MarkInput) {
      let div = (
        <div>
          <span>x,y</span>
          <input
            onChange={(event) => {
              MarkInput(event.target.value);
            }}
          />
        </div>
      );
      return div;
    },
    getInitialState: function () {
      return {
        // url: 'http://nemanjakovacevic.net/wp-content/uploads/2013/07/placeholder.png'
        // url:'http://www.amicus.nieruchomosci.pl/grafika/no-image.png'
        // url: 'https://bytesizemoments.com/wp-content/uploads/2014/04/placeholder.png'
        url: img_placeholder, // IdealStudio.Config.image_placeholder,
        allowDeformed: true,
      };
    },
    getDefaultMarkValue(state) {
      return 50 + "," + 50;
    },
    getRenderTemplate: function (state, props) {
      let marks = props.marks || {};
      // let Mark = ({ idKey, title, style, color }) => (
      //     );
      let markElements = Object.keys(marks).map((id) => {
        let value = marks[id].value;
        let title = marks[id].title;
        let color = marks[id].color;

        let position;
        if (value && value.split(",").length === 2) {
          position = value.split(",");
        } else {
          position = [0, 0];
        }
        return (
          <MarkEditor
            key={id}
            style={{ position: "absolute", top: position[0] + "%", left: position[1] + "%" }}
            time={1.5}
            onRichMarkMoved={props.onRichMarkMoved}
            mark={id}
            base={base}
            marks={marks}
            state={state}
          >
            <Mark
              style={{ position: "absolute", top: position[0] + "%", left: position[1] + "%" }}
              color={color}
              idKey={id}
              title={title}
            />
          </MarkEditor>
        );
      });

      return <Image markElements={markElements} state={state} props={props} />;
    },
    parseRichMarkInput: function (x, y, width, height, toolbarState, boxId) {
      // x/y zaten cursor offset (12,20) cikarilarak pin ikonunun sol-ust
      // kosesine getirildi; tekrar +12/+26 eklemek uc noktasini saga-asagi
      // kaydiriyordu.
      let xx = (x * 100) / width;
      let yy = (y * 100) / height;
      let finalValue = yy.toFixed(2) + "," + xx.toFixed(2);

      return finalValue;
    },
    validateValueInput: function (value) {
      let regex = /(^-*\d+(?:\.\d*)?),(-*\d+(?:\.\d*)?$)/g;
      let match = regex.exec(value);
      if (match && match.length === 3) {
        let x = Math.round(parseFloat(match[1]) * 100) / 100;
        let y = Math.round(parseFloat(match[2]) * 100) / 100;
        if (isNaN(x) || isNaN(y) /* || x > 100 || y > 100 || x < -100 || y < -100*/) {
          return { isWrong: true, message: i18n.t("AnimationOptions.message_mark_xy") };
        }
        value = x + "," + y;
      } else {
        return { isWrong: true, message: i18n.t("AnimationOptions.message_mark_xy") };
      }
      return { isWrong: false, value: value };
    },
  };
}
